import { createSlice } from "@reduxjs/toolkit";

const initialState = { projects: [], selectedProject: null, loading: false };

const projectSlice = createSlice({
    name: "projects",
    initialState,
    reducers: {
        setProjects(state, action) {
            /**Sets the full array of projects */
            state.projects = action.payload;
        },
        addProject(state, action) {
            state.projects = [...state.projects, action.payload];
        },
        removeProject(state, action) {
            state.projects = state.projects.flatMap((project) => {
                if (project.id === action.payload) {
                    if (project.deleted === false) {
                        return [{ ...project, deleted: true }];
                    } else {
                        return []
                    }
                }
                return [project];
            }
            );
            if (state.selectedProject?.id === action.payload) {
                state.selectedProject = null;
            }
        },
        restoreProject(state, action) {
            state.projects = state.projects.map((project) => {
                if (project.id === action.payload) {
                    return { ...project, deleted: false };
                }
                return project;
            }
            );
            if (state.selectedProject?.id === action.payload) {
                state.selectedProject = { ...state.selectedProject, deleted: false };
            }
        },
        clearProjects(state) {
            state.projects = [];
        },
        setProjectLoading(state, action) {
            state.loading = action.payload;
        },
        updateProject(state, action) {
            const nextState = state.projects.map((project) => {
                if (project.id === action.payload.id) {
                    return action.payload;
                }
                return project;
            });
            state.projects = nextState;
            state.selectedProject = {
                ...action.payload,
                phases: action.payload.phases.sort((a, b) => a.id - b.id)
            }
            localStorage.setItem('selectedProject', action.payload.id);
        },
        updatePhaseName(state, action) {
            state.selectedProject = { ...state.selectedProject, phases: state.selectedProject.phases.map((phase) => {
                if (phase.id === action.payload.id) {
                    return {
                        ...phase,
                        phase_name: action.payload.newName
                    };
                }
                return phase;
            }) };
        },
        updateLoopName(state, action) {
            state.selectedProject = { ...state.selectedProject, phases: state.selectedProject.phases.map((phase) =>  ({
                ...phase,
                loops: phase.loops.map((loop) => {
                    if (loop.id === action.payload.id) {
                        return {
                            ...loop,
                            name: action.payload.newName
                        };
                    }
                    return loop;
                })
            }))
            };
        },
        updateLoopLength(state, action) {
            state.selectedProject = { ...state.selectedProject, phases: state.selectedProject.phases.map((phase) => ({
                ...phase,
                loops: phase.loops.map((loop) => {
                    if (loop.id === action.payload.id) {
                        return {
                            ...loop,
                            length: action.payload.length
                        };
                    }
                    return loop;
                })
            }))
            };
            state.loop = {
                ...state.loop,
                length: action.payload.length
            };
        },
        updateLoopData(state, action) {
            state.selectedProject = { ...state.selectedProject, phases: state.selectedProject.phases.map((phase) => ({
                ...phase,
                loops: phase.loops.map((loop) => {
                    if (loop.id === action.payload.id) {
                        return {
                            ...loop,
                            ...action.payload
                        };
                    }
                    return loop;
                })
            }))
            };
            state.loop = {
                ...state.loop,
                ...action.payload
            };
        },
        removeLastLoop(state) {
            const oldPhases = state.selectedProject.phases
            const lastPhase = oldPhases[oldPhases.length - 1]

            // If the last phase has only one loop, simply delete the entire phase
            if (lastPhase.loops.length === 1) {
                state.selectedProject = {
                    ...state.selectedProject,
                    phases: oldPhases.slice(0, -1)
                }
            // If the last phase has more than one loop, delete the last loop and keep the phase
            } else {
                state.selectedProject = { 
                    ...state.selectedProject, 
                    phases: [
                        ...oldPhases.slice(0, -1),
                        {...lastPhase, loops: lastPhase.loops.slice(0, -1)}
                    
                    ]
                }
            }
        },
        removeProjectSubtheme(state, action) {
            state.selectedProject = {
                ...state.selectedProject,
                themes: state.selectedProject.themes.map((theme) => {
                    if (theme.id === action.payload.themeID) {
                        return {
                            ...theme,
                            subthemes: theme.subthemes.filter((subtheme) => subtheme.id !== action.payload.subthemeID),
                        };
                    }
                    return theme;
                }),
            };
        },
        setSelectedProject(state, action) {
            state.selectedProject = action.payload;
        },
        setReferenceDesign(state, action) {
            state.selectedProject = { ...state.selectedProject, reference_design: action.payload };
        },
        setLoopReferenceDesign(state, action) {
            const { loopId, phaseId, referenceDesign } = action.payload;
            state.selectedProject = {
                ...state.selectedProject,
                phases: state.selectedProject.phases.map((phase) => {
                    if (phase.id === phaseId) {
                        return {
                            ...phase,
                            loops: phase.loops.map((loop) => {
                                if (loop.id === loopId) {
                                    return {
                                        ...loop,
                                        reference_design: referenceDesign,
                                    };
                                }
                                return loop;
                            }),
                        };
                    }
                    return phase;
                }),
            };
        },  
        updateStatus(state, action) {
            state.selectedProject = { ...state.selectedProject, status: action.payload.status };
        },
        updateDesign(state, action) {
            // require phase ID and loop ID in payload
            const updatedDesign = action.payload;
            if (!updatedDesign.loop) {
                state.selectedProject = {
                    ...state.selectedProject,
                    reference_design: updatedDesign,
                };
            } else {
                const updatedProject = {
                    ...state.selectedProject,
                    phases: state.selectedProject.phases.map((phase) => {
                        if (phase.id === action.payload.phase) {
                            return {
                                ...phase,
                                loops: phase.loops.map((loop) => {
                                    if (loop.id === action.payload.loop) {
                                        return {
                                            ...loop,
                                            designs: loop.designs.map((design) => {
                                                if (design.id === action.payload.id) {
                                                    return action.payload;
                                                }
                                                return design;
                                            }),
                                            reference_design: loop?.reference_design?.id === action.payload.id ? action.payload : loop.reference_design
                                        };
                                    } else {
                                        return loop;
                                    }
                                }),
                            };
                        } else {
                            return phase;
                        }
                    }),
                };
                state.selectedProject = updatedProject;
            }
        },
        addDesign(state, action) {
            // require phase ID and loop ID in payload
            const newDesign = action.payload;
            if (!newDesign.loop) {
                state.selectedProject = {
                    ...state.selectedProject,
                    reference_design: newDesign,
                };
            } else {
                const updatedProject = {
                    ...state.selectedProject,
                    phases: state.selectedProject.phases.map((phase) => {
                        if (phase.id === action.payload.phase) {
                            return {
                                ...phase,
                                loops: phase.loops.map((loop) => {
                                    if (loop.id === newDesign.loop) {
                                        return {
                                            ...loop,
                                            designs: [...loop.designs, newDesign],
                                        };
                                    } else {
                                        return loop;
                                    }
                                }),
                            };
                        } else {
                            return phase;
                        }
                    }),
                };
                state.selectedProject = updatedProject;
            }
        },
        removeDesign(state, action) {
            // require phase ID and loop ID in payload
            if (!action.payload.loop) {
                state.selectedProject = {
                    ...state.selectedProject,
                    reference_design: null,
                };
            } else {
                const updatedProject = {
                    ...state.selectedProject,
                    phases: state.selectedProject.phases.map((phase) => {
                        if (phase.id === action.payload.phase) {
                            return {
                                ...phase,
                                loops: phase.loops.map((loop) => {
                                    if (loop.id === action.payload.loop) {
                                        return {
                                            ...loop,
                                            designs: loop.designs.filter((design) => design.id !== action.payload.designID),
                                            reference_design: loop?.reference_design?.id === action.payload.designID ? null : loop.reference_design
                                        };
                                    } else {
                                        return loop;
                                    }
                                }),
                            };
                        } else {
                            return phase;
                        }
                    }),
                };
                state.selectedProject = updatedProject;
            }
        },
        updateScores(state, action) {
            // require phase ID, loop ID, projectThemeID, projectSubthemeID
            if (!action.payload.loop) {
                state.selectedProject = {
                    ...state.selectedProject,
                    reference_design: {
                        ...state.selectedProject.reference_design,
                        scores: state.selectedProject.reference_design.scores.map((score) =>
                            score.id === action.payload.id ? action.payload : score
                        ),
                        scores_by_themes: {
                            ...state.selectedProject.reference_design.scores_by_themes,
                            [action.payload.themeID]: {
                                ...state.selectedProject.reference_design.scores_by_themes[action.payload.themeID],
                                [action.payload.subthemeID]: [
                                    ...state.selectedProject.reference_design.scores_by_themes[action.payload.themeID][action.payload.subthemeID].map(
                                        (score) => (score.id === action.payload.id ? action.payload : score)
                                    ),
                                ],
                            },
                        },
                    },
                };
            } else {
                const updatedProject = {
                    ...state.selectedProject,
                    phases: state.selectedProject.phases.map((phase) => {
                        if (phase.id === action.payload.phase) {
                            return {
                                ...phase,
                                loops: phase.loops.map((loop) => {
                                    if (loop.id === action.payload.loop) {
                                        return {
                                            ...loop,
                                            designs: loop.designs.map((design) => {
                                                if (design.id === action.payload.design) {
                                                    return {
                                                        ...design,
                                                        scores: design.scores.map((score) =>
                                                            score.id === action.payload.id ? action.payload : score
                                                        ),
                                                        scores_by_themes: {
                                                            ...design.scores_by_themes,
                                                            [action.payload.themeID]: {
                                                                ...design.scores_by_themes[action.payload.themeID],
                                                                [action.payload.subthemeID]: [
                                                                    ...design.scores_by_themes[action.payload.themeID][action.payload.subthemeID].map(
                                                                        (score) => (score.id === action.payload.id ? action.payload : score)
                                                                    ),
                                                                ],
                                                            },
                                                        },
                                                    };
                                                }
                                                return design;
                                            }),
                                        };
                                    } else {
                                        return loop;
                                    }
                                }),
                            };
                        } else {
                            return phase;
                        }
                    }),
                };
                state.selectedProject = updatedProject;
            }
        },
        setPossibleLayers(state, action) {
            state.selectedProject = { ...state.selectedProject, possibleLayers: action.payload };
        },
        addProjectAttachment(state, action) {
            state.selectedProject = {
                ...state.selectedProject,
                attachments: [...state.selectedProject.attachments, action.payload],
            };
        },
        removeProjectAttachment(state, action) {
            state.selectedProject = {
                ...state.selectedProject,
                attachments: state.selectedProject.attachments.filter((attachment) => attachment.id !== action.payload),
            };
        },
        updateProjectAttachment(state, action) {
            state.selectedProject = {
                ...state.selectedProject,
                attachments: state.selectedProject.attachments.map((attachment) => {
                    if (attachment.id === action.payload.id) {
                        return action.payload;
                    }

                    return attachment;
                }),
            };
        },
        updateAdvice(state, action) {
            // Accept either shape:
            // 1) { phase, loop, themeID, advice }
            // 2) advice object with merged keys: { id, text, attachments, phase, loop, themeID }
            const { phase: phaseID, loop: loopID, themeID } = action.payload;
            const adviceObj = action.payload.advice ? action.payload.advice : action.payload;
            state.selectedProject = {
                ...state.selectedProject,
                phases: state.selectedProject.phases.map((phase) => {
                    if (phase.id !== phaseID) return phase;
                    return {
                        ...phase,
                        loops: phase.loops.map((loop) => {
                            if (loop.id !== loopID) return loop;
                            return {
                                ...loop,
                                advice_by_themes: {
                                    ...loop.advice_by_themes,
                                    [themeID]: adviceObj,
                                },
                            };
                        }),
                    };
                }),
            };
        },
        // Update a single design score for loop-based scoring without touching scores_by_themes
        updateLoopDesignScore(state, action) {
            const updatedScore = action.payload;
            
            const phaseID = action.payload.phase;
            const loopID = action.payload.loop;
            if (!state.selectedProject) return;
            state.selectedProject = {
                ...state.selectedProject,
                phases: state.selectedProject.phases.map((phase) => {
                    if (phase.id !== phaseID) return phase;
                    return {
                        ...phase,
                        loops: phase.loops.map((loop) => {
                            if (loop.id !== loopID) return loop;
                            return {
                                ...loop,
                                designs: loop.designs.map((design) => {
                                    if (design.id !== updatedScore.design) return design;
                                    return {
                                        ...design,
                                        scores: design.scores.map((s) => (s.id === updatedScore.id ? updatedScore : s)),
                                    };
                                }),
                                reference_design: loop.reference_design && {
                                    ...loop.reference_design,
                                    scores: loop.reference_design.scores.map((s) => (s.id === updatedScore.id ? updatedScore : s)),
                                }
                            };
                        }),
                    };
                }),
            };
        },
        // Loop management updates mirrored into selectedProject
        addLoopThemeInProject(state, action) {
            const loopTheme = action.payload;
            if (!state.selectedProject) return;
            state.selectedProject = {
                ...state.selectedProject,
                phases: (state.selectedProject.phases || []).map((phase) => ({
                    ...phase,
                    loops: (phase.loops || []).map((loop) =>
                        loop.id === loopTheme.loop
                            ? { ...loop, loop_themes: [...(loop.loop_themes || []), loopTheme] }
                            : loop
                    ),
                })),
            };
        },
        updateLoopThemeInProject(state, action) {
            const loopTheme = action.payload;
            if (!state.selectedProject) return;
            state.selectedProject = {
                ...state.selectedProject,
                phases: (state.selectedProject.phases || []).map((phase) => ({
                    ...phase,
                    loops: (phase.loops || []).map((loop) => {
                        if (loop.id !== loopTheme.loop) return loop;
                        return {
                            ...loop,
                            loop_themes: (loop.loop_themes || []).map((lt) => (lt.id === loopTheme.id ? loopTheme : lt)),
                        };
                    }),
                })),
            };
        },
        removeLoopThemeInProject(state, action) {
            const loopThemeId = action.payload;
            if (!state.selectedProject) return;
            state.selectedProject = {
                ...state.selectedProject,
                phases: (state.selectedProject.phases || []).map((phase) => ({
                    ...phase,
                    loops: (phase.loops || []).map((loop) => ({
                        ...loop,
                        loop_themes: (loop.loop_themes || []).filter((lt) => lt.id !== loopThemeId),
                    })),
                })),
            };
        },
        addLoopKPIInProject(state, action) {
            const loopKPI = action.payload;
            if (!state.selectedProject) return;
            state.selectedProject = {
                ...state.selectedProject,
                phases: (state.selectedProject.phases || []).map((phase) => ({
                    ...phase,
                    loops: (phase.loops || []).map((loop) =>
                        loop.id === loopKPI.loop
                            ? { ...loop, loop_kpis: [...(loop.loop_kpis || []), loopKPI] }
                            : loop
                    ),
                })),
            };
        },
        updateLoopKPIInProject(state, action) {
            const loopKPI = action.payload;
            if (!state.selectedProject) return;
            state.selectedProject = {
                ...state.selectedProject,
                phases: (state.selectedProject.phases || []).map((phase) => ({
                    ...phase,
                    loops: (phase.loops || []).map((loop) => {
                        if (loop.id !== loopKPI.loop) return loop;
                        return {
                            ...loop,
                            loop_kpis: (loop.loop_kpis || []).map((lk) => (lk.id === loopKPI.id ? loopKPI : lk)),
                        };
                    }),
                })),
            };
        },
        removeLoopKPIInProject(state, action) {
            const loopKPIId = action.payload;
            if (!state.selectedProject) return;
            state.selectedProject = {
                ...state.selectedProject,
                phases: (state.selectedProject.phases || []).map((phase) => ({
                    ...phase,
                    loops: (phase.loops || []).map((loop) => ({
                        ...loop,
                        loop_kpis: (loop.loop_kpis || []).filter((lk) => lk.id !== loopKPIId),
                    })),
                })),
            };
        },
        addLoopLayerInProject(state, action) {
            const loopLayer = action.payload;
            if (!state.selectedProject) return;
            state.selectedProject = {
                ...state.selectedProject,
                phases: (state.selectedProject.phases || []).map((phase) => ({
                    ...phase,
                    loops: (phase.loops || []).map((loop) =>
                        loop.id === loopLayer.loop
                            ? { ...loop, loop_layers: [...(loop.loop_layers || []), loopLayer] }
                            : loop
                    ),
                })),
            };
        },
        removeLoopLayerInProject(state, action) {
            const loopLayerId = action.payload;
            if (!state.selectedProject) return;
            state.selectedProject = {
                ...state.selectedProject,
                phases: (state.selectedProject.phases || []).map((phase) => ({
                    ...phase,
                    loops: (phase.loops || []).map((loop) => ({
                        ...loop,
                        loop_layers: (loop.loop_layers || []).filter((ll) => ll.id !== loopLayerId),
                    })),
                })),
            };
        },
        addLoopSegmentInProject(state, action) {
            const loopSegment = action.payload;
            if (!state.selectedProject) return;
            state.selectedProject = {
                ...state.selectedProject,
                phases: (state.selectedProject.phases || []).map((phase) => ({
                    ...phase,
                    loops: (phase.loops || []).map((loop) =>
                        loop.id === loopSegment.loop
                            ? { ...loop, loop_segments: [...(loop.loop_segments || []), loopSegment] }
                            : loop
                    ),
                })),
            };
        },
        updateLoopSegmentInProject(state, action) {
            const loopSegment = action.payload;
            if (!state.selectedProject) return;
            state.selectedProject = {
                ...state.selectedProject,
                phases: (state.selectedProject.phases || []).map((phase) => ({
                    ...phase,
                    loops: (phase.loops || []).map((loop) => {
                        if (loop.id !== loopSegment.loop) return loop;
                        return {
                            ...loop,
                            loop_segments: (loop.loop_segments || []).map((ls) => (ls.id === loopSegment.id ? loopSegment : ls)),
                        };
                    }),
                })),
            };
        },
        removeLoopSegmentInProject(state, action) {
            const loopSegmentId = action.payload;
            if (!state.selectedProject) return;
            state.selectedProject = {
                ...state.selectedProject,
                phases: (state.selectedProject.phases || []).map((phase) => ({
                    ...phase,
                    loops: (phase.loops || []).map((loop) => ({
                        ...loop,
                        loop_segments: (loop.loop_segments || []).filter((ls) => ls.id !== loopSegmentId),
                    })),
                })),
            };
        },
        addLoopGoalInProject(state, action) {
            const loopGoal = action.payload; // includes loop and loop_theme
            if (!state.selectedProject) return;
            state.selectedProject = {
                ...state.selectedProject,
                phases: (state.selectedProject.phases || []).map((phase) => ({
                    ...phase,
                    loops: (phase.loops || []).map((loop) => {
                        if (loop.id !== loopGoal.loop) return loop;
                        return {
                            ...loop,
                            loop_themes: (loop.loop_themes || []).map((lt) =>
                                lt.id === loopGoal.loop_theme
                                    ? { ...lt, goals: [...(lt.goals || []), loopGoal] }
                                    : lt
                            ),
                            loop_kpis: (loop.loop_kpis || []).map((lk) =>
                                lk.id === loopGoal.loop_kpi
                                    ? { ...lk, loop_goals: [...(lk.loop_goals || []), loopGoal] }
                                    : lk
                            ),
                        };
                    }),
                })),
            };
        },
        updateLoopGoalInProject(state, action) {
            const loopGoal = action.payload; // includes loop, loop_theme (legacy) and loop_kpi (new)
            if (!state.selectedProject) return;
            state.selectedProject = {
                ...state.selectedProject,
                phases: (state.selectedProject.phases || []).map((phase) => ({
                    ...phase,
                    loops: (phase.loops || []).map((loop) => {
                        if (loop.id !== loopGoal.loop) return loop;
                        return {
                            ...loop,
                            loop_themes: (loop.loop_themes || []).map((lt) =>
                                lt.id === loopGoal.loop_theme
                                    ? {
                                          ...lt,
                                          goals: (lt.goals || []).map((g) => (g.id === loopGoal.id ? loopGoal : g)),
                                      }
                                    : lt
                            ),
                            loop_kpis: (loop.loop_kpis || []).map((lk) =>
                                lk.id === loopGoal.loop_kpi
                                    ? {
                                          ...lk,
                                          loop_goals: (lk.loop_goals || []).map((g) => (g.id === loopGoal.id ? loopGoal : g)),
                                      }
                                    : lk
                            ),
                        };
                    }),
                })),
            };
        },
        removeLoopGoalInProject(state, action) {
            const loopGoalId = action.payload;
            if (!state.selectedProject) return;
            state.selectedProject = {
                ...state.selectedProject,
                phases: (state.selectedProject.phases || []).map((phase) => ({
                    ...phase,
                    loops: (phase.loops || []).map((loop) => ({
                        ...loop,
                        loop_themes: (loop.loop_themes || []).map((lt) => ({
                            ...lt,
                            goals: (lt.goals || []).filter((g) => g.id !== loopGoalId),
                        })),
                    })),
                })),
            };
        },
    },
});

export const {
    setProjects,
    addProject,
    removeProject,
    restoreProject,
    clearProjects,
    setProjectLoading,
    updateProject,
    updatePhaseName,
    updateLoopName,
    updateLoopLength,
    updateLoopData,
    removeLastLoop,
    removeProjectSubtheme,
    setSelectedProject,
    setReferenceDesign,
    setLoopReferenceDesign,
    updateDesign,
    addDesign,
    removeDesign,
    updateScores,
    updateStatus,
    addProjectAttachment,
    removeProjectAttachment,
    updateProjectAttachment,
    updateAdvice,
    addLoopThemeInProject,
    updateLoopThemeInProject,
    removeLoopThemeInProject,
    addLoopKPIInProject,
    updateLoopKPIInProject,
    removeLoopKPIInProject,
    addLoopLayerInProject,
    removeLoopLayerInProject,
    addLoopSegmentInProject,
    updateLoopSegmentInProject,
    removeLoopSegmentInProject,
    addLoopGoalInProject,
    updateLoopGoalInProject,
    removeLoopGoalInProject,
    updateLoopDesignScore
} = projectSlice.actions;
export default projectSlice.reducer;
